import {
  evolve, lensPath,
  compose, omit,
  set, over
} from 'ramda';

import { requestEvolve, failEvolve, successEvolve } from './reducerUtill';
import { confirmWorkhoursActions } from './confirmWorkHoursReportReducer';


export const confirmatorsActions = {
  request: 'CONFIRMATORS_REQUEST',
  success: 'CONFIRMATORS_SUCCESS',
  fail: 'CONFIRMATORS_FAIL'
};

export const confirmatorActions = {
  update: {
    request: 'CONFIRMATOR_UPDATE_REQUEST',
    success: 'CONFIRMATOR_UPDATE_SUCCESS'
  },
  delete: {
    request: 'CONFIRMATOR_DELETE_REQUEST',
    success: 'CONFIRMATOR_DELETE_SUCCESS'
  }
};

export const confirmatorsRequest = (payload) => ({
  type: confirmatorsActions.request,
  payload
});

export const confirmatorUpdate = (payload) => ({
  type: confirmatorActions.update.request,
  payload
});

export const confirmatorDelete = (id) => ({
  type: confirmatorActions.delete.request,
  payload: id
});

const initialState = {
  list: {},
  levels: {},
  pending: false,
  error: null
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case confirmatorsActions.request: 
      return evolve(requestEvolve, { ...state, list: [] });
    case confirmatorsActions.fail: 
      return evolve(failEvolve(payload), state);
    case confirmatorsActions.success: 
      return compose(
        evolve(successEvolve),
        set(lensPath(['list']), payload)
      )(state);
    case confirmatorActions.update.success: {
      const confirmator = payload;
      const { id } = confirmator;
      return set(lensPath(['list', id]), confirmator, state);
    }
    case confirmatorActions.delete.success: {
      return over(lensPath(['list']), omit([payload]), state);
    }
    case confirmWorkhoursActions.confirmLevels.success: {
      return ({ ...state, levels: payload });
    }
    default:
      return state;
  }
};